import { useReduxDialogControls } from '../common/utils/dialogUtils';
import IconButton from '../components/buttons/IconButton';
import { useMainMenuDrawerStyles } from './MainMenuDrawer.styles';

export default function MainMenuTrigger() {
  const { open } = useReduxDialogControls({ id: 'mainMenu' });
  const { styles } = useMainMenuDrawerStyles();
  return (
    <IconButton
      icon="bars icon-21"
      className={styles.mainMenuTrigger}
      onClick={open}
      data-subject="mainMenu"
      data-action="open"
    />
  );
}
